/* Auvra PDP: gallery thumbs, variant ladder / option-pill price sync, qty stepper, Klarna line, sticky ATC. Vanilla, no deps. */
(function () {
  'use strict';
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    return (format || '£{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* gallery */
  document.querySelectorAll('[data-auvra-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
        var tpl = btn.querySelector('template');
        if (tpl && main) {
          var frag = document.createElement('div'); frag.innerHTML = tpl.innerHTML;
          var next = frag.firstElementChild;
          var cur = main.querySelector('img, video, iframe, model-viewer, .product__media');
          if (next) { if (cur) { cur.replaceWith(next); } else { main.prepend(next); } }
        }
      });
    });
  });

  /* qty stepper */
  document.querySelectorAll('[data-auvra-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.dir === 'up' ? 1 : -1));
        input.value = v;
      });
    });
  });

  /* variant sync (ladder radios or select) */
  document.querySelectorAll('[data-auvra-product]').forEach(function (root) {
    var data = root.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var format = root.getAttribute('data-money-format') || '£{{amount}}';
    var idInput = root.querySelector('form [name="id"]');

    function selectVariant(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-price-target]').forEach(function (el) {
        var badge = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<span class="auvra-badge auvra-badge--sale">−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>' : '';
        var was = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<s>' + money(v.compare_at_price, format) + '</s> ' : '';
        el.innerHTML = '<span class="auvra-price' + (was ? '' : ' auvra-price--regular') + '">'
          + was + '<strong>' + money(v.price, format) + '</strong> ' + badge + '</span>';
      });
      root.querySelectorAll('[data-av-klarna]').forEach(function (el) {
        el.textContent = 'or 3 interest-free payments of ' + money(Math.floor(v.price / 3), format) + ' with Klarna';
      });
      setAtc(v.available, v.available ? null : 'Sold out');
    }
    function setAtc(enabled, label) {
      root.querySelectorAll('[data-atc]').forEach(function (atc) {
        atc.disabled = !enabled;
        atc.textContent = enabled ? (atc.getAttribute('data-label') || 'Add to Basket') : (label || 'Sold out');
      });
    }

    /* option pills (one control per product option): resolve the variant from every
       selected option value, then grey out values with no available combination */
    var pills = root.querySelector('[data-av-pills]');
    function pillGroups() {
      return Array.prototype.slice.call(pills.querySelectorAll('[data-av-option]')).sort(function (a, b) {
        return parseInt(a.getAttribute('data-av-option'), 10) - parseInt(b.getAttribute('data-av-option'), 10);
      });
    }
    function groupValue(g) {
      var sel = g.querySelector('select');
      if (sel) return sel.value;
      var r = g.querySelector('input[type="radio"]:checked');
      return r ? r.value : null;
    }
    function matches(v, selected, skip) {
      var o = v.options || [];
      for (var i = 0; i < selected.length; i++) {
        if (i === skip) continue;
        if (selected[i] != null && o[i] !== selected[i]) return false;
      }
      return true;
    }
    function syncPills() {
      var groups = pillGroups();
      var selected = groups.map(groupValue);
      /* disable values that have no available variant given the other selections */
      groups.forEach(function (g, gi) {
        var controls = g.querySelectorAll('input[type="radio"], option');
        controls.forEach(function (c) {
          var ok = variants.some(function (v) {
            return v.available && (v.options || [])[gi] === c.value && matches(v, selected, gi);
          });
          c.disabled = !ok;
          if (c.type === 'radio') {
            var lab = g.querySelector('label[for="' + c.id + '"]');
            if (lab) lab.classList.toggle('is-unavailable', !ok);
          }
        });
      });
      var exact = variants.find(function (v) {
        return (v.options || []).length === selected.length && matches(v, selected, -1);
      });
      if (exact) {
        selectVariant(exact.id);
      } else {
        if (idInput) idInput.value = '';
        setAtc(false, 'Unavailable');
      }
    }
    if (pills) {
      pills.addEventListener('change', syncPills);
      syncPills();
    }

    root.querySelectorAll('[data-variant-select]').forEach(function (ctrl) {
      if (ctrl.hasAttribute('data-av-pills')) return;
      ctrl.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.value) selectVariant(t.value);
      });
    });
    var checked = root.querySelector('[data-variant-select]:not([data-av-pills]) input:checked');
    if (checked) selectVariant(checked.value);
  });

  /* scroll-for-more cue: fades once the visitor has scrolled; click scrolls to the first section below the buy box */
  document.querySelectorAll('[data-av-scrollcue]').forEach(function (cue) {
    var shown = true;
    function onScroll() {
      var hide = window.scrollY > 140;
      if (hide === !shown) return;
      shown = !hide; cue.classList.toggle('is-hidden', hide);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    cue.addEventListener('click', function (e) {
      e.preventDefault();
      var sec = cue.closest('.shopify-section');
      var target = sec && sec.nextElementSibling ? sec.nextElementSibling : null;
      var y = target ? target.getBoundingClientRect().top + window.scrollY - 24 : window.innerHeight * 0.9;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  /* sticky ATC */
  var sticky = document.querySelector('[data-auvra-sticky]');
  var sentinel = document.querySelector('[data-sticky-sentinel]');
  if (sticky && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        /* keep the a11y tree in sync: hidden bar is out of the tab order,
           visible bar is exposed and focusable */
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        sticky.querySelectorAll('button, a, input, select').forEach(function (el) {
          if (visible) { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', '-1'); }
        });
      });
    }, { threshold: 0 }).observe(sentinel);
  }
})();

/* v5.1 */
/* ============================================================================================
   v5.1 (23 Sep 2026) — PDP section rail (snippets/auvra-section-rail.liquid).
   Progressive: the rail is a plain row of anchor links without this script. Here it is moved
   out of the product section so position:sticky spans the whole page, pinned directly under the
   sticky header (which hides on scroll-down), the item in view is underlined via
   IntersectionObserver, and items whose target section did not render are removed.
   ============================================================================================ */
(function () {
  'use strict';
  var rail = document.querySelector('[data-av-rail]');
  if (!rail) return;
  var links = Array.prototype.slice.call(rail.querySelectorAll('[data-av-rail-link]'));
  var targets = [];
  links.forEach(function (a) {
    var id = a.getAttribute('data-av-rail-link');
    var el = id ? document.getElementById(id) : null;
    if (el) { targets.push({ id: id, el: el, link: a }); }
    else if (a.parentNode && a.parentNode.tagName === 'LI') { a.parentNode.parentNode.removeChild(a.parentNode); }
  });
  if (targets.length < 2) { return; } /* nothing worth a rail */

  /* move the rail next to the header so sticky works page-wide (not inside the theme editor,
     where sections are re-rendered in place) */
  var main = document.getElementById('MainContent');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (main && main.parentNode && !designMode) {
    main.parentNode.insertBefore(rail, main);
    rail.classList.add('av-rail--js');
  }

  /* keep the rail glued to the bottom edge of the header, including while the header slides away */
  var header = document.querySelector('.section-header') || document.querySelector('.shopify-section-group-header-group');
  var root = document.documentElement;
  var raf = null;
  function place() {
    raf = null;
    var top = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, r.bottom);
    }
    root.style.setProperty('--av-rail-top', top + 'px');
    root.style.setProperty('--av-rail-h', rail.offsetHeight + 'px');
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(place); }
  place();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', place);

  /* active item: the last target whose top has passed the rail */
  var activeId = null;
  function setActive(id) {
    if (id === activeId) return;
    activeId = id;
    targets.forEach(function (t) {
      var on = t.id === id;
      t.link.classList.toggle('is-active', on);
      if (on) { t.link.setAttribute('aria-current', 'location'); } else { t.link.removeAttribute('aria-current'); }
    });
    var active = rail.querySelector('.av-rail__link.is-active');
    if (active && active.scrollIntoView) {
      try { active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) { /* older engines */ }
    }
  }
  function pick() {
    var line = (parseFloat(root.style.getPropertyValue('--av-rail-top')) || 0) + rail.offsetHeight + 8;
    var current = targets[0].id;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].el.getBoundingClientRect().top <= line) current = targets[i].id;
    }
    /* order in the DOM can differ from the rail order (Delivery/FAQ live inside the main section):
       prefer the deepest target that is actually on screen */
    var onScreen = targets.filter(function (t) {
      var r = t.el.getBoundingClientRect();
      return r.top <= line && r.bottom > line;
    });
    if (onScreen.length) current = onScreen[onScreen.length - 1].id;
    setActive(current);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function () { pick(); }, { rootMargin: '-10% 0px -60% 0px', threshold: [0, 0.1, 0.5, 1] });
    targets.forEach(function (t) { io.observe(t.el); });
  }
  var pickRaf = null;
  window.addEventListener('scroll', function () { if (!pickRaf) pickRaf = requestAnimationFrame(function () { pickRaf = null; pick(); }); }, { passive: true });
  pick();

  /* smooth in-page scroll that respects the rail height (anchors already carry scroll-margin-top) */
  rail.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-av-rail-link]') : null;
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-av-rail-link'));
    if (!el) return;
    e.preventDefault();
    if (el.tagName === 'DETAILS') el.open = true; /* Delivery / FAQ accordions open on arrival */
    try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { el.scrollIntoView(); }
    if (history.replaceState) history.replaceState(null, '', '#' + a.getAttribute('data-av-rail-link'));
  });
})();
